import { styled } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';

export const StyledContainer = styled(Grid)`
  background: ${(props) => props.theme.colors.neutral['000']};
`;

export const StyledTitle = styled.div`
  font-size: 16px;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;
